__webpack_require__.p = "https://images-qa.forumm.to/2968/_next/";